import './GroupPlayer.css'
import { Draggable } from 'react-beautiful-dnd'
import { memo } from 'react'

import { ReactComponent as ButtonDelete } from '../../icon/minus-delete.svg'
import { ReactComponent as DND } from '../../icon/dnd.svg'

const GroupPlayerComponent = ({
	replacingItem,
	index,
	nodesCount,
	groupType,
	droppableId,
	node,
	type,
	editingMode,
	excludeParticipant,
	dndDisabled
}) => {
	const defineStyles = (isDragging, provided) => {
		const dropItem = replacingItem?.droppableId === droppableId && replacingItem?.index === index ? true : false
		let style = {
			display: 'flex',
			alignItems: 'center',
			padding: '0 5px'
		}

		if (groupType === 'olympic_plus' && index % 2 === 1 && nodesCount - 1 > index && !isDragging && !dropItem) {
			style = {
				...style,
				borderBottom: '1px solid #858585'
			}
		} else if (nodesCount - 1 > index && !isDragging && !dropItem) {
			style = {
				...style,
				borderBottom: '1px solid #CCC'
			}
		}

		if (isDragging) {
			return {
				...provided.draggableProps.style,
				...style,
				backgroundColor: '#EBF4FF',
				borderRadius: '2px',
				border: '2px solid #4694D9'
			}
		} else if (dropItem) {
			return {
				...provided.draggableProps.style,
				...style,
				backgroundColor: '#F3F3F3',
				borderRadius: '2px',
				border: '2px solid #4694D9'
			}
		} else if (node?.disabled) {
			return {
				...provided.draggableProps.style,
				...style,
				backgroundColor: '#E8E8E8'
			}
		} else {
			return {
				...style,
				...provided.draggableProps.style,
				backgroundColor: 'transparent'
			}
		}
	}

	return (
		<>
			{
				type === 'singles' &&
				<Draggable
					draggableId={node?.nodeUid}
					index={index}
					isDragDisabled={node?.buy && node?.disabled ? true : false}
				>
					{
						(provided, snapshot) => (
							<div
								key={index}
								className="group-player__single-container"
								ref={provided.innerRef}
								{...provided.draggableProps}
								style={
									defineStyles(snapshot.isDragging, provided)
								}
							>
								{
									groupType === 'round_robin' &&
									<div className="group-player__order">
										<p className="group-player__number">{index + 1}</p>
									</div>
								}

								<p
									className="group-player__single-name"
								// onClick={() => handleName(index, node)}
								>
									{
										!node?.disabled &&
										node?.rating &&
										`(${node?.rating})`
									} {node?.name}
								</p>

								<div className="group-player__deletion">
									{
										editingMode ?
											<>
												<ButtonDelete
													className="icon-deletion"
													onClick={() => excludeParticipant(node)}
												/>
											</>
											:
											<div
												{...provided.dragHandleProps}
												className="group-player__dnd"
												style={
													node?.disabled || dndDisabled ?
														{ display: 'none' } : {}
												}
											>
												<DND />
											</div>
									}
								</div>
							</div>
						)
					}
				</Draggable>
			}

			{
				type === 'doubles' &&
				<Draggable
					draggableId={node?.nodeUid}
					index={index}
					isDragDisabled={node?.buy && node?.disabled ? true : false}
				>
					{
						(provided, snapshot) => (
							<div
								key={index}
								className="group-player__double-container"
								ref={provided.innerRef}
								{...provided.draggableProps}
								style={
									defineStyles(snapshot.isDragging, provided)
								}
							>
								{
									groupType === 'round_robin' &&
									<div className="group-player__order">
										<p className="group-player__number">{index + 1}</p>
									</div>
								}

								{
									node?.rating &&
									<p className="group-player__double-rating">
										({node?.rating})
									</p>
								}

								{
									node?.noPlayer ?
										<div
											className="group-player__double"
										// onClick={() => handleName(index, node)}
										>
											<p className="group-player__double-noplayer">
												{node?.name}
											</p>
										</div>
										:
										<div
											className="group-player__double"
										// onClick={() => handleName(index, node)}
										>
											<p className="group-player__double-name">
												{node?.firstPlayerName}
											</p>

											<p className="group-player__double-name">
												{node?.secondPlayerName}
											</p>
										</div>
								}

								<div className="group-player__deletion">
									{
										editingMode ?
											<>
												<ButtonDelete
													className="icon-deletion"
													onClick={() => excludeParticipant(node)}
												/>
											</>
											:
											<div
												{...provided.dragHandleProps}
												className="group-player__dnd"
												style={
													node?.disabled || dndDisabled ?
														{ display: 'none' }
														:
														{}
												}
											>
												<DND />
											</div>
									}
								</div>
							</div>
						)
					}
				</Draggable>
			}
		</>
	)
}

export const GroupPlayer = memo(GroupPlayerComponent)